<template>
  <div>

    <div id="banner">
      <div class="swiper-container" id="home_banner_swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(image, index) in images" :key="index">
            <img :data-src="image.src" class="swiper-lazy" :alt="image.alt">
          </div>
        </div>
      </div>
      <div class="content content-pb">
        <h2>
          Herzlich Willkommen<br>
          <span>bei der Herdenschutz UG <span class="small">(haftungsbeschränkt)</span></span><br>
          <span>Ihr schlaft - Wir wachen</span>
        </h2>
      </div>
    </div>

    <Philosophy id="philosophy"></Philosophy>
    <Overview id="overview"></Overview>
    <Project id="project"></Project>
    <Goals id="goals"></Goals>
    <SensitiveData id="sensitive-data"></SensitiveData>
    <!-- <Questions id="questions"></Questions> -->
    <Contact id="contact"></Contact>

  </div>
</template>

<script>
import Philosophy from '@/components/Philosophy.vue'
import Overview from '@/components/Overview.vue'
import SensitiveData from '@/components/SensitiveData.vue'
import Goals from '@/components/Goals.vue'
//import Questions from '@/components/Questions.vue'
import Contact from '@/components/Contact.vue'
import Project from '@/components/Project.vue'

export default {
  name: 'Home',
  components: {
    Philosophy,
    Overview,
    SensitiveData,
    Goals,
    Contact,
    Project
  },
  data: () => {
    return {
      images: [
        { src: 'banner_2.jpg', alt: 'Pferd und Fohlen' },
        { src: 'banner_3.jpg', alt: 'Schafsweide' },
        { src: 'banner_4.jpg', alt: 'Milchvieh im Stall' },
        { src: 'banner_1.jpg', alt: 'Milchvieh auf Weide' }
      ]
    }
  },
  mounted: function(){
    new window.Swiper ('#home_banner_swiper', {
      loop: true,
      autoplay: {
        delay: 5000,
      },
      lazy: {
        loadPrevNext: true
      }
    });
  }
}
</script>

<style scoped>
div.content {
  height: 100%;
}

div#banner {
  height: 75vh;
  position: relative;
}

div#banner div.swiper-container {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

div#banner div.swiper-container img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  -o-object-fit: cover;
}

div#banner h2 {
  color: #fff;
  position: absolute;
  font-size: 3.8em;
  text-transform: uppercase;
  line-height: 1em;
  bottom: 10%;
  z-index: 1;
  width: calc(100% - 4em);
  text-shadow: 0 0 .1em #000;
}

div#banner h2 span {
  font-size: .8em;
  line-height: .5em;
}

div#banner h2 span.small {
  font-size: .45em;
  text-transform: none;
}

@media only screen and (max-width: 760px) {
  div#banner h2 {
    font-size: 2em;
  }
}
</style>
